import React from 'react';

interface Props {
  attributeNamesToTransform?: {[key: string]: string},
  currentlyAppliedAttributes: {[key: string]: string[]},
  onRemove: (key: string, value: string) => void,
}

// TODO: Consider refactoring to use array of data objects, rather than children prop
const CustomCurrentRefinements: React.FC<Props> = ({
  attributeNamesToTransform = {},
  currentlyAppliedAttributes,
  onRemove,
  children = null,
}) => {
  const getLabel = (key: string, value: string): string => {
    return key === 'city' ? decodeURIComponent(value).replace(/\+/g, ' ') : value;
  };

  return (
    <div className="ais-CurrentRefinements">
      <ul className="ais-CurrentRefinements-list">
        {Object.keys(currentlyAppliedAttributes)
          .filter((key) => {
            return Array.isArray(currentlyAppliedAttributes[key])
              && currentlyAppliedAttributes[key].length > 0;
          })
          .map((key) => {
            const label = attributeNamesToTransform[key] || key;
            return (
              <li key={key} className="ais-CurrentRefinements-item">
                <span className="ais-CurrentRefinements-label">{`${label}:`}</span>
                {currentlyAppliedAttributes[key].map((value) => {
                  return (
                    <span
                      key={`${key}-${value}`}
                      className="ais-CurrentRefinements-category"
                    >
                      <span
                        className="ais-CurrentRefinements-categoryLabel"
                      >
                        {getLabel(key, value)}
                      </span>
                      <button
                        className="ais-CurrentRefinements-delete"
                        onClick={() => onRemove(key, value)}
                      >
                        ✕
                      </button>
                    </span>
                  );
                })}
              </li>
            );
          })}
        {children}
      </ul>
    </div>
  );
};

export default CustomCurrentRefinements;
